<template>
  <div class="vue_flex vue_column">
    <div class="cont_wrapper">
      <div class="cont_wrapper_sx">
        <div class="shaixuan_left">
          <!-- <div class="shaixuan_item h">
            <div class="shaixuan_item_con">
              <img
                class="shaixuan_item_icon"
                src="../../../../../assets/ym/tjsj@2x.png"
                alt=""
              />
              <div class="shaixuan_item_tit">统计时间</div>
            </div>
            <el-date-picker
              v-model="listQuery.time"
              type="datetimerange"
              range-separator=""
              start-placeholder=""
              end-placeholder=""
              value-format="timestamp"
              class="vue_flex_item"
              placeholder="选择日期"
            ></el-date-picker>
          </div> -->
          <div class="shaixuan_item h">
            <div class="shaixuan_item_con">
              <img
                class="shaixuan_item_icon"
                src="../../../../../assets/ym/dp@2x.png"
                alt=""
              />
              <div class="shaixuan_item_tit">店铺</div>
            </div>
            <el-select
              v-model="listQuery.shopid"
              placeholder="请选择"
              class="vue_flex_item"
            >
              <el-option
                v-for="item in dpList"
                :key="item.shopid"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="shaixuan_btns">
          <!-- <div class="shaixuan_btn1 h">设置</div> -->
          <div class="shaixuan_btn1 h" @click="qingchu">清除</div>
          <div class="shaixuan_btn2 h" @click="search">查询</div>
        </div>
      </div>

      <div class="vue_flex vue_flex_around">
        <div class="vue_flex vue_column vue_align_center">
          <p
            class="vue-font-PingFang-500 color_35 font26 line_height_26"
            style="margin: 61px 0px 29px"
          >
            本月销售收入目标达成率
          </p>
          <div id="piemoonChart"></div>
        </div>
        <div class="vue_flex vue_column vue_align_center">
          <p
            class="vue-font-PingFang-500 color_35 font26 line_height_26"
            style="margin: 61px 0px 29px"
          >
            本年销售收入目标达成率
          </p>
          <div id="pieyearChart"></div>
        </div>
      </div>

      <div class="home_title">
        <div class="home_tit vue_flex vue_align_center">
          销售收入目标达成率趋势
          <p
            class="p_text h"
            :class="listQuery.datetype === 'month' ? 'active_p' : ''"
            @click="datetClick('month')"
          >
            月
          </p>
          <p
            class="p_text h"
            :class="listQuery.datetype === 'year' ? 'active_p' : ''"
            @click="datetClick('year')"
          >
            年
          </p>
        </div>
      </div>
      <div id="myChart"></div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import * as echarts from "echarts";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import linkwhole from "@/components/linkwhole/index";

export default {
  components: { Pagination, linkwhole },
  data() {
    return {
      dpList: [],

      total: 0,
      listQuery: {
        leixing: "zhichu", // zhichu fahuo
        type: "1", // //1淘宝2京东3天猫
        datetype: "month", //month year
        shopid: "",
      },

      charts: "",
      opinionData: [],

      userObj: {},
      piemyear: null,
      piemoon: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      // this.drawLine("myChart");
    });
  },

  created() {
    this.mubiaoZhuizongFun();
    this.mubiaoZhuizongFun1()
    this.getdpListFun();
    this.mubiaoZhuizong_echartFun();
  },

  methods: {
    datetClick(type) {
      console.log('type',type);
      if (this.listQuery.datetype === type) return;
      this.$set(this.listQuery, "datetype", type);
      console.log('listQuery',this.listQuery);
      this.search();
    },

    drawLine(id, row) {
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        backgroundColor: "white", // 设置图表背景为白色
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["近七日收益"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true,
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: row.x,
        },
        yAxis: {
          type: "value",
        },

        series: [
          {
            name: "近七日收益",
            type: "line",
            stack: "总量",
            itemStyle: { normal: { areaStyle: { type: "default" } } },
            data: row.y,
          },
        ],
      });
    },

    piemoonFun(mubiaoxiaoshoushouru, xiaoshoushouru) {
      // 3. 确保DOM已挂载，获取容器（优先用$refs，比getElementById更可靠）
      const chartDom = document.getElementById("piemoonChart");
      if (!chartDom) {
        console.error("未找到饼图容器：pieyearChart");
        return;
      }

      // 4. 初始化ECharts实例
      this.piemoon = echarts.init(chartDom);

      // 5. 修复radius配置（设置内/外半径，饼图才能显示）
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          x: "center",
          y: "top",
          data: ["计划销售额", "实际销售额"], // 修正图例名称，与数据匹配
        },
        toolbox: {
          show: true,
        },
        calculable: true,
        series: [
          {
            name: "销售额统计", // 修正系列名称，更贴合业务
            type: "pie",
            radius: ["40%", "70%"], // 内半径40%，外半径70%（环形饼图，也可设为['0%', '70%']实心）
            center: ["50%", "50%"], // 饼图居中（可选，默认居中）
            data: [
              { value: mubiaoxiaoshoushouru || 0, name: "计划销售额" }, // 用动态参数，兜底0避免NaN
              { value: xiaoshoushouru || 0, name: "实际销售额" }, // 修正数据名称，与图例匹配
            ],
            // 可选：自定义颜色，提升辨识度
            color: ["#409EFF", "#67C23A"],
          },
        ],
      };
       // 6. 设置配置项并渲染
       this.piemoon.setOption(option);

      // 7. 监听窗口resize，自适应（避免重复绑定，先移除再添加）
      window.removeEventListener("resize", this.handleResize);
      window.addEventListener("resize", this.handleResize);

    },


    piemyearFun(mubiaoxiaoshoushouru, xiaoshoushouru) {
      // 3. 确保DOM已挂载，获取容器（优先用$refs，比getElementById更可靠）
      const chartDom = document.getElementById("pieyearChart");
      if (!chartDom) {
        console.error("未找到饼图容器：pieyearChart");
        return;
      }

      // 4. 初始化ECharts实例
      this.piemyear = echarts.init(chartDom);

      // 5. 修复radius配置（设置内/外半径，饼图才能显示）
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          x: "center",
          y: "top",
          data: ["计划销售额", "实际销售额"], // 修正图例名称，与数据匹配
        },
        toolbox: {
          show: true,
        },
        calculable: true,
        series: [
          {
            name: "销售额统计", // 修正系列名称，更贴合业务
            type: "pie",
            radius: ["40%", "70%"], // 内半径40%，外半径70%（环形饼图，也可设为['0%', '70%']实心）
            center: ["50%", "50%"], // 饼图居中（可选，默认居中）
            data: [
              { value: mubiaoxiaoshoushouru || 0, name: "计划销售额" }, // 用动态参数，兜底0避免NaN
              { value: xiaoshoushouru || 0, name: "实际销售额" }, // 修正数据名称，与图例匹配
            ],
            // 可选：自定义颜色，提升辨识度
            color: ["#409EFF", "#67C23A"],
          },
        ],
      };
       // 6. 设置配置项并渲染
       this.piemyear.setOption(option);

      // 7. 监听窗口resize，自适应（避免重复绑定，先移除再添加）
      window.removeEventListener("resize", this.handleResize);
      window.addEventListener("resize", this.handleResize);
    },

    qingchu() {
      Object.keys(this.listQuery).forEach(key =>{
        this.listQuery[key] = ""
      })
      this.$set(this.listQuery, 'type', "1")
      this.$set(this.listQuery, 'leixing', "zhichu")
      this.$set(this.listQuery, 'datetype', "month")
      this.mubiaoZhuizongFun()
      this.mubiaoZhuizong_echartFun()
    },
    search() {
      this.mubiaoZhuizongFun()
      this.mubiaoZhuizong_echartFun()
    },

    async mubiaoZhuizongFun() {
      const res = await this.$http.get(this.$urls.mubiaoZhuizong, {...this.listQuery, datetype: 'month'});
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.$nextTick(function () {
        this.piemoonFun(res.mubiaoxiaoshoushouru, res.xiaoshoushouru);

      });
    },
    async mubiaoZhuizongFun1() {
      const res = await this.$http.get(this.$urls.mubiaoZhuizong, {...this.listQuery, datetype: 'year'});
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.$nextTick(function () {
        this.piemyearFun(res.mubiaoxiaoshoushouru, res.xiaoshoushouru);
      });
    },

    async mubiaoZhuizong_echartFun() {
      const res = await this.$http.get(this.$urls.mubiaoZhuizong_echart, this.listQuery);
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.$nextTick(function () {
        this.drawLine("myChart", res.wanchenglvEcharts);
      });
    },


    // 店铺列表
    async getdpListFun() {
      const res = await this.$http.get(this.$urls.getshoplist, {
        page: 1,
        limit: 10000,
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.dpList = res.list;
    },

    getHetongListFun() {},
  },
};
</script>

<style lang="scss" scoped>
#myChart {
  width: 1508px;
  height: 300px;
}

#piemoonChart {
  width: 308px;
  height: 300px;
}
#pieyearChart {
  width: 308px;
  height: 300px;
}

.home_title {
  width: 100%;
  height: 55px;
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .home_tit {
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 26px;
    color: #232323;
  }
  .home_right {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    .home_right_2 {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      margin-left: 10px;
    }
    .home_right_1 {
      padding: 0 10px;
      width: 108px;
      height: 45px;
      background: #f4f5f9;
      border-radius: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
    }
  }
}
.shaixuan_btns {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  .shaixuan_btn1 {
    width: 132px;
    height: 55px;
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #999999;
    text-align: center;
    line-height: 55px;
    margin-right: 25px;
  }
  .shaixuan_btn2 {
    width: 131px;
    height: 54px;
    background: #195cf8;
    border-radius: 10px;
    text-align: center;
    line-height: 55px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
  }
}
.cont_wrapper {
  padding: 25px;
  .cont_wrapper_sx {
    width: 1527px;
    height: 71px;
    background: #f5f5f5;
    border-radius: 10px;
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .shaixuan_left {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
    }
    .shaixuan_item {
      width: 350px;
      height: 54px;
      background: #ffffff;
      border-radius: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      margin-right: 22px;
      .shaixuan_item_con {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        .shaixuan_item_tit {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #232323;
        }
        .shaixuan_item_sel {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #999999;
        }
        .shaixuan_item_arr {
          width: 13px;
          height: 8px;
          margin-left: 10px;
        }
        .shaixuan_item_icon {
          width: 29px;
          height: 24px;
          margin-right: 10px;
        }
      }
    }
  }
}

.p_text {
  width: 72px;
  height: 52px;
  line-height: 52px;
  border-radius: 10px;
  text-align: center;
}

.active_p {
  background: #eee;
}

.shaixuan_item {
  /deep/ .el-date-editor {
    border: none !important;
    text-align: right;
    font-size: 18px;
    width: 196px;
  }

  /deep/ .el-input__icon {
    display: none;
  }

  .el-input /deep/.el-input__inner {
    border: none !important;
    text-align: right;
    font-size: 18px;
  }
  .el-input /deep/.el-input__prefix {
    display: none !important;
  }

  .el-select /deep/.el-input__inner {
    border: none !important;
    text-align: right;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/taobao/target/index.vue